// src/components/map/GameLocationButton.tsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Button } from 'semantic-ui-react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { Game } from '../../app/models/Game';

interface Props {
  game: Game;
}

export const GameLocationButton: React.FC<Props> = ({ game }: Props) => {
  const { t } = useTranslation();
  const [isMapOpen, setIsMapOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsMapOpen(true)}
        style={{
          padding: '4px 8px',
          background: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '0.9em'
        }}
      >
        {t('gameLocationButton.viewLocation')}
      </button>

      <Modal 
        open={isMapOpen} 
        onClose={() => setIsMapOpen(false)}
        size="small"
      >
        <Modal.Header>
          {t('gameLocationButton.locationTitle', { gameName: game.gameName })}
          <Button 
            icon="close" 
            size="mini" 
            floated="right" 
            onClick={() => setIsMapOpen(false)} 
            style={{ padding: '0px', marginTop: '-5px' }}
            title={t('gameLocationButton.closeButton')}
          />
        </Modal.Header>
        <Modal.Content>
          <MapContainer 
            center={[game.latitude, game.longitude]} 
            zoom={14} 
            style={{ height: '400px', width: '100%' }}
          >
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={[game.latitude, game.longitude]}>
              <Popup>
                <strong>{game.gameName}</strong><br />
                {t('gameLocationButton.locationCoordinates')}<br />
                {game.latitude.toFixed(6)}, {game.longitude.toFixed(6)}
              </Popup>
            </Marker>
          </MapContainer>
        </Modal.Content>
      </Modal>
    </>
  );
};